// extracted by mini-css-extract-plugin
module.exports = {"UtilityBoxItem":"utility-box-item-v2_UtilityBoxItem__ALeT3","childWrapper":"utility-box-item-v2_childWrapper__aqhjN","icon":"utility-box-item-v2_icon__yqiUr"};